import React, {useState} from "react";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import {Tooltip} from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import OnlinePlayerListDialog from "../onlineplayerlist/OnlinePlayerListDialog";
import {useOnlinePlayers} from "../../status/StatusContext";

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function PlayerCounter() {

    const [isOnlinePlayerListDialogVisible, setIsOnlinePlayerListDialogVisible] = useState(false);

    const playerCount = useOnlinePlayers();

    return (
        <>
            <OnlinePlayerListDialog visible={isOnlinePlayerListDialogVisible}
                                    onClose={() => setIsOnlinePlayerListDialogVisible(false)}/>
            <IconButton
                size="large"
                type='button'
                onClick={() => setIsOnlinePlayerListDialogVisible(true)}
                color="inherit"
                style={squareHighlightStyle}
            >
                <Badge badgeContent={playerCount} color="info">
                    <Tooltip title='Online Players'>
                        <PeopleIcon/>
                    </Tooltip>
                </Badge>
            </IconButton>
        </>
    );
}